import { Component, OnInit, Input } from "@angular/core";
import { Router } from "@angular/router";
import { ActivatedRoute } from "@angular/router";
import { SharedDataService } from "src/app/shared-data.service";
import { DataService } from "src/app/data.service";
import { ToastService } from "ng-uikit-pro-standard";
import { GUID } from "./../../guid";
import {
  FormArray,
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
} from "@angular/forms";
import { MatTableDataSource, MatSort, MatPaginator } from "@angular/material";

@Component({
  selector: "app-recordtypelayout",
  templateUrl: "./recordtypelayout.component.html",
  styleUrls: ["./recordtypelayout.component.scss"],
})
export class RecordtypelayoutComponent implements OnInit {
  formData: any;
  layout: Array<any>;
  profiles = [];
  recordType: any;
  recordTypeLayout: any;
  storedFormChanges: any[] = [];

  mode = "";
  name = "";
  labelname = "";
  recordTypeId = "";
  recordTypeProfileId = "";
  recordTypeLayoutId = "";

  metaobjectId = "";
  isLoading = false;
  isError = false;
  errorMessage = "";
  metalayoutList = [];
  sharedDetailForm: FormGroup;
  DetailForm: FormGroup;
  guid: GUID;

  detailForm = this.fb.group({
    metaobjectid: "",
    id: "",
    displayname: "",
    name: "",
    description: "",
    layout: "",
    layoutname: "",
    layoutid: "",
    active: true,
    profilename: "",
    profileid: "",
  });
  displayedColumns: string[] = ["profile", "layout"];
  dataSource = new MatTableDataSource<any>();
  constructor(
    private route: ActivatedRoute,
    private dataService: DataService,
    private router: Router,
    private sharedDataService: SharedDataService,
    private fb: FormBuilder,
    private toastrService: ToastService
  ) {
    this.sharedDetailForm = this.fb.group({
      metaobjectid: "",
      id: "",
      displayname: "",
      name: "",
      description: "",
      layout: [""],
      layoutname: "",
      layoutid: "",
      profilename: "",
      active: true,
    });
  }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.mode = this.route.snapshot.params.mode;
      this.name = this.route.snapshot.params.name;
      this.metaobjectId = this.route.snapshot.params.metaobjectid;
      this.recordTypeId = this.route.snapshot.params.recordtypeid;

      console.log(this.metaobjectId);
    });
    this.guid = new GUID();

    this.sharedDataService.formData$.subscribe((data) => {
      this.formData = data;
    });
    console.log(this.formData);
    this.name = this.formData.formData.name;
    this.labelname = this.formData.formData.displayname;
    console.log(this.name);
    this.getMetalayout();
    this.getActiveProfiles();
    if (this.mode.toLowerCase() == "edit") {
      this.getRecordTypeById();
      this.getRecordTypeLayouts();
    }
    const layoutControl = new FormControl("");

    // this.sharedDetailForm = this.fb.group({
    //   layout: layoutControl,
    // });
  }

  showSuccess(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-top-right",
      timeOut: 3000,
    };
    this.toastrService.success(data, "", options);
  }

  showError(data: any) {
    let options = { enableHtml: true, positionClass: "md-toast-bottom-right" };
    this.toastrService.error(data, "Application Error!", options);
  }

  showWarning(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-bottom-right",
      messageClass: "orange darken-4",
      toastClass: "warning-color-dark",
    };
    this.toastrService.warning(data, "", options);
  }

  // layoutChange(event: { value: string; label: any }) {
  //   console.log("processChange", event);
  //   if (event.value.trim() != "") {
  //     this.detailForm.controls["layoutname"].setValue(event.value);
  //     this.detailForm.controls["layoutid"].setValue(event.label);
  //   } else {
  //     this.detailForm.controls["layoutname"].setValue("");
  //     this.detailForm.controls["layoutid"].setValue("");
  //   }
  // }

  layoutChange(
    event: { value: string; label: any },
    profilename: any,
    profileid: any
  ) {
    console.log("layoutChange", event);
    console.log("profilename", profilename);
    console.log("profileid", profileid);

    const form = this.detailForm;

    const formChanges = {
      layoutname: event.label,
      layoutid: event.value,
      profilename: profilename,
      profileid: profileid,
    };

    const existingIndex = this.storedFormChanges.findIndex(
      (change) => change.profileid === profileid
    );

    if (existingIndex !== -1) {
      // Update the existing entry
      this.storedFormChanges[existingIndex] = formChanges;
    } else {
      // Add the changes to the array
      this.storedFormChanges.push(formChanges);
    }
    if (event.value.trim() !== "") {
      form.controls["layoutname"].setValue(event.label);
      form.controls["layoutid"].setValue(event.value);
      form.controls["profilename"].setValue(profilename);
      form.controls["profileid"].setValue(profileid);
    } else {
      form.controls["layoutname"].setValue("");
      form.controls["layoutid"].setValue("");
      form.controls["profilename"].setValue("");
      form.controls["profileid"].setValue("");
    }
    // this.storedFormChanges.push(formChanges);

    console.log(form);
    console.log(this.storedFormChanges);
  }

  defaultlayoutChange(event: { value: string; label: any }, profilename: any) {
    console.log("layoutChange", event);
    console.log("name", profilename);

    const form = this.sharedDetailForm;
    if (event.value.trim() !== "") {
      form.controls["layoutname"].setValue(event.label);
      form.controls["layoutid"].setValue(event.value);
      form.controls["profilename"].setValue(profilename);
    } else {
      form.controls["layoutname"].setValue("");
      form.controls["layoutid"].setValue("");
      form.controls["profilename"].setValue("");
    }
    console.log(form);
  }

  // layoutChange(event: { value: string; label: any }, profilename: any) {
  //   console.log('layoutChange', event);
  //   console.log('name', profilename);

  //   const layoutControl = this.sharedDetailForm.get('layout');

  //   if (event.value.trim() !== '') {
  //     layoutControl.setValue(event.value);
  //   } else {
  //     layoutControl.setValue('');
  //   }

  //   // Rest of your logic
  //   console.log(this.sharedDetailForm);
  // }

  getMetalayout() {
    return new Promise((resolve, reject) => {
      console.log("getMetalayout");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          // sortfield: this.sorting.fieldName,
          // sortorder: this.sorting.order,
          metalayout: {
            metaobjectid: this.metaobjectId,
            // layouttype: "Page Layout",
            // name: "AcademicSession_New_general",
          },
        },
      };
      console.log("postOption", postOption);

      this.isLoading = true;
      this.dataService.getLayouts(postOption).subscribe(
        (res) => {
          console.log("metalayout list", res);
          if (res !== null && res.success == 1) {
            // this.metalayoutList = res.data.metalayouts;
            this.metalayoutList = res.data.metalayouts.filter(
              (layout) =>
                layout.layouttype === null ||
                layout.layouttype === "Page Layout" ||
                layout.layouttype === "undefined"
            );

            if (res !== null && res.success == 1) {
              var activelayout = res.data.metalayouts;
              var layoutArr = [];
              //just add an empty entry sice this field is optional
              layoutArr.push({ value: "", label: "--None--" });
              for (let i = 0; i < activelayout.length; i++) {
                layoutArr.push({
                  value: activelayout[i].id,
                  label: activelayout[i].name,
                });
              }
              this.layout = layoutArr;
              console.log(layoutArr);

              this.isLoading = false;
              resolve(null);
            } else {
              console.log("No process data!");
              this.errorMessage =
                res != null ? res.message : "No process data!";
              this.isError = true;
              this.isLoading = false;
              resolve(null);
            }
            console.log(this.metalayoutList);

            this.isLoading = false;
            resolve(null);
          } else {
            console.log("No layouts data!");
            this.errorMessage = res != null ? res.message : "No layouts data!";
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  getActiveProfiles() {
    return new Promise((resolve, reject) => {
      console.log("getActiveProfiles");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          profile: {
            userlicense: localStorage.getItem("crm_userlicense"),
          },
        },
      };
      console.log("postOption", postOption);
      this.isLoading = true;
      this.dataService.getActiveProfileByUserLicense(postOption).subscribe(
        (res) => {
          console.log(res);
          if (res !== null && res.success == 1) {
            this.profiles = res.data.profiles;
            this.dataSource.data = this.profiles;

            this.isLoading = false;
            resolve(null);
          } else {
            console.log("No profile data!");
            this.errorMessage = res != null ? res.message : "No profile data!";
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  getRecordTypeById() {
    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      // domain: localStorage.getItem("domain"),
      // subdomain: localStorage.getItem("subdomain"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      data: {
        recordtype: {
          id: this.recordTypeId,
        },
      },
    };

    this.isLoading = true;
    console.log(postOption);
    this.dataService.getRecordTypeById(postOption).subscribe(
      (res) => {
        //alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          this.recordType = res.data.recordtype;
          if (this.recordType != null) {
            this.sharedDetailForm.controls["layoutid"].setValue(
              this.recordType.defaultlayoutid
            );

            this.sharedDetailForm.controls["layout"].setValue(
              this.recordType.defaultlayoutid
            );

            // this.detailForm.controls.parentobject.patchValue(this.recordType.process);
          }
          this.isLoading = false;
          console.log(this.sharedDetailForm.controls["layoutid"]);
          console.log(this.recordType.defaultlayoutid);
        } else {
          console.log("no data");
          this.isLoading = false;
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.errorMessage = err.message;
        this.isError = true;
        this.isLoading = false;
      }
    );
  }

  getRecordTypeLayouts() {
    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      // domain: localStorage.getItem("domain"),
      // subdomain: localStorage.getItem("subdomain"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      data: {
        recordtypelayout: {
          recordtypeid: this.recordTypeId,
        },
      },
    };

    this.isLoading = true;
    console.log(postOption);
    this.dataService.getRecordTypeLayouts(postOption).subscribe(
      (res) => {
        //alert('****res****' + JSON.stringify(res));
        console.log("data@@@@@@@@@@@@@@@@@", res);
        // if (res.success == 1) {
        //   this.recordTypeLayout = res.data.recordtypelayout;
        //   if (this.recordTypeLayout != null) {
        //     this.detailForm.controls["layoutid"].setValue(
        //       this.recordTypeLayout.layoutid
        //     );

        //     this.detailForm.controls["layout"].setValue(
        //       this.recordTypeLayout.layoutid
        //     );

        //     // this.detailForm.controls.parentobject.patchValue(this.recordType.process);
        //   }
        //   this.isLoading = false;
        //   // console.log(this.sharedDetailForm.controls["layoutid"]);
        //   // console.log(this.recordType.defaultlayoutid);
        // }
        if (res.success == 1) {
          this.recordTypeLayout = res.data.recordtypelayout;
          console.log(this.recordTypeLayout);
          if (this.recordTypeLayout != null) {
            for (const element of this.recordTypeLayout) {
              this.detailForm.controls["layoutid"].setValue(element.layoutid);

              this.detailForm.controls["layout"].setValue(element.layoutid);
              this.detailForm.controls["profilename"].setValue(
                element.profilename
              );
              this.detailForm.controls["profileid"].setValue(element.profileid);

              // const formChanges = {
              //   layoutid: element.layoutid,
              //   layoutname: element.layoutname,
              //   profilename: element.profilename,
              //   profileid: element.profileid,
              // };

              // this.storedFormChanges.push(formChanges);
              this.layoutChange(
                { value: element.layoutid, label: element.layoutname },
                element.profilename,
                element.profileid
              );
            }
            this.isLoading = false;
          }
        } else {
          console.log("no data");
          this.isLoading = false;
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.errorMessage = err.message;
        this.isError = true;
        this.isLoading = false;
      }
    );
    console.log("storedFormChanges NOW =", this.storedFormChanges);
  }

  save() {
    this.isLoading = false;
    this.isError = false;
    // if (this.detailForm.controls["displayname"].value.toString().trim() == "") {
    //   this.showWarning("Recordtype label is mandatory");
    //   return;
    // }
    // if (this.detailForm.controls["name"].value.toString().trim() == "") {
    //   this.showWarning("Recordtype name is mandatory");
    //   return;
    // }

    // if (this.detailForm.invalid) {
    //   this.errorMessage = "The fields [Label] and [Name] are mandatory.";
    //   return;
    // }

    console.log("mode", this.mode);
    if (this.mode.toLowerCase() == "new") {
      this.recordTypeId = this.guid.getGUID("recordtype");
    }

    //prepare data for saving: application
    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      useralias: localStorage.getItem("crm_useralias"),
      data: {
        recordtype: {
          metaobjectid: this.formData.metaobjectid,
          mode: this.mode,
          id: this.recordTypeId,
          displayname: this.formData.formData.displayname,
          defaultlayoutid: this.sharedDetailForm.controls["layoutid"].value,
          name: this.formData.formData.name,
          processname: this.formData.formData.processname,
          processid: this.formData.formData.processid,
          description: this.formData.formData.description,
          mastertype: false,
          active: this.formData.formData.active,
          recordtypelayout: [],
          recordtypeprofile: [],
        },
      },
    };

    console.log("postOption", postOption);

    var arrRecordtypeLayout = [];
    for (let recordTypeLayout of this.storedFormChanges) {
      if (
        this.mode.toLowerCase() == "new" ||
        this.mode.toLowerCase() == "edit"
      ) {
        this.recordTypeLayoutId = this.guid.getGUID("recordtypelayout");
      }
      var recordtypelayouts = {
        // organizationid: localStorage.getItem("crm_orgid"),
        // userid: localStorage.getItem("crm_userid"),
        // username: localStorage.getItem("crm_username"),
        // useralias: localStorage.getItem("crm_useralias"),
        // data: {
        // recordtypelayout: {
        // metaobjectid: this.formData.metaobjectid,
        // mode: this.mode,
        id: this.recordTypeLayoutId,
        recordtypeid: this.recordTypeId,
        profilename: recordTypeLayout.profilename,
        profileid: recordTypeLayout.profileid,
        // displayname: this.formData.formData.displayname,
        layoutid: recordTypeLayout.layoutid,
        layoutname: recordTypeLayout.layoutname,
        // recordtypeid: this.recordTypeId,
        // name: this.formData.formData.name,
        // processname: this.formData.formData.processname,
        // processid: this.formData.formData.processid,
        // description: this.formData.formData.description,
        mastertype: false,
        // active: this.formData.formData.active,
        // },
        // },
      };

      //push it to array
      arrRecordtypeLayout.push(recordtypelayouts);
    }

    var arrRecordtypeProfile = [];
    for (let recordTypeProfile of this.formData.formDatas) {
      if (
        this.mode.toLowerCase() == "new" ||
        this.mode.toLowerCase() == "edit"
      ) {
        this.recordTypeProfileId = this.guid.getGUID("recordtypeprofile");
      }
      var recordtypeprofiles = {
        id: this.recordTypeProfileId,
        recordtypeid: this.recordTypeId,
        profilename: recordTypeProfile.profilename,
        profileid: recordTypeProfile.profileid,
        isdefault: recordTypeProfile.makedefault,
        isavailable: recordTypeProfile.makeavailable,

        metaobjectid: this.metaobjectId,
      };

      //push it to array
      arrRecordtypeProfile.push(recordtypeprofiles);
    }

    // console.log("postOption1", postOption1);
    postOption.data.recordtype.recordtypelayout = arrRecordtypeLayout;
    postOption.data.recordtype.recordtypeprofile = arrRecordtypeProfile;

    console.log(postOption);
    this.isLoading = true;
    // this.dataService.upsertRecordType(postOption).subscribe(
    //   (res) => {
    //     //alert('****res****' + JSON.stringify(res));
    //     console.log(res);
    //     if (res.success == 1) {
    //       this.showSuccess(res.message);
    //       this.isLoading = false;
    //       // this.router.navigateByUrl('/home/recordtypedetail/' + this.recordTypeId + '/' + this.detailForm.controls['name'].value.trim() +
    //       //   '/' + this.metaobjectId + '/' + this.metaobjectName );
    //     } else {
    //       console.log("error while saving");
    //       this.showError(res.message);
    //       this.isLoading = false;
    //     }
    //   },
    //   (err) => {
    //     console.log("Error***:", err);
    //     this.showError(err.message);
    //     this.isError = true;
    //     this.isLoading = false;
    //   }
    // );
  }
}
